import React from 'react';

const Spiner = () => {
  return (
    <div className="spinner text-center">
      <div className="spinner__wrapper">
        <div className="fs-preloader dark-blue">
            <div className="page"><hr /><hr /><hr /></div>
            <div className="page page1 turn"><hr /><hr /><hr /></div>
            <div className="page page2 turn"><hr /><hr /><hr /></div>
            <div className="page page3 turn"><hr /><hr /><hr /></div>
            <div className="page page4 turn"><hr /><hr /><hr /></div>
            <div className="page page5 turn"><hr /><hr /><hr /></div>
            <div className="page page6 turn"><hr /><hr /><hr /></div>
            <div className="page"><hr /><hr /><hr /></div>
        </div>
      </div>
    </div>
  );
};

export default Spiner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js